module.exports = __webpack_public_path__ + "static/media/qr-help-right.8047fdad.svg";